function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#fc2a00;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M1531.957,927.947v1.714h-9.374a1.583,1.583,0,0,1-.655-.117,1.335,1.335,0,0,1-.454-.359c-.02-.019-8.992-10.866-8.992-10.866v5.315a8.424,8.424,0,0,1-.335,2.461c-.012.041-.024.078-.035.12a5.276,5.276,0,0,1-1.1,1.959,4.839,4.839,0,0,1-1.789,1.225c-.016.007-.031.011-.047.018a6.96,6.96,0,0,1-2.557.435,10.749,10.749,0,0,1-1.311-.078,8.968,8.968,0,0,1-1.171-.2l0-1.916a.593.593,0,0,1,.2-.416.752.752,0,0,1,.525-.161,2.6,2.6,0,0,1,.549.082,3.662,3.662,0,0,0,.86.082,3.758,3.758,0,0,0,1.247-.191,2.119,2.119,0,0,0,.908-.618,2.792,2.792,0,0,0,.552-1.1,6.271,6.271,0,0,0,.185-1.637v-11h1.8a3.29,3.29,0,0,1,.371.019.946.946,0,0,1,.265.071.867.867,0,0,1,.229.154,2.194,2.194,0,0,1,.244.263l.41.494,8.976,10.851c-.03-.228-.042-8.325-.046-11a.872.872,0,0,1,.9-.849h2.494v14.361h6.219a.914.914,0,0,1,.937.889",
  transform: "translate(-1498.042 -901.274)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M1512.17,928.248h0a16.6,16.6,0,1,1,16.6-16.6,16.6,16.6,0,0,1-16.6,16.6m0-36.6a20,20,0,1,0,20,20A20,20,0,0,0,1512.17,891.646Z",
  transform: "translate(-1492.17 -891.646)"
});

var SvgGroup25 = function SvgGroup25(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40.001,
    viewBox: "0 0 40 40.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGroup25, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group25.ba194783.svg";
export { ForwardRef as ReactComponent };